import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setSelectedProcess, setShowMenu, setShowSideMenu } from '../../reduxStore/actions/flowActions';
import { store } from '../../reduxStore/store';

import cls from './Modules.module.scss';

import * as R from 'ramda';
import { setOnBoardingModalsVisibility } from '../../reduxStore/actions/modalsActions';

function ProcessesMenu(props) {
	const navigate = useNavigate();
	const { onSetSelectedProcess, companyProcesses, user, workflowTemplates, companyData } = props;
	const { onBoardingModalsVisibility, isOnboarding } = props;
	
	
	const {
		firstModalVisible,
	} = onBoardingModalsVisibility;

	return (
		<div className={cls.listContainer} style={{ minWidth: '200px' }}>
			{companyData?.status !== 'superadmin' && companyProcesses?.length > 0
				? R.sortWith([R.ascend(R.prop('name'))])(companyProcesses.filter(proc => proc.user_id === user.id || user.is_admin === true))?.slice(0, 10).map((item, index) => (
					<button
						key={index}
						className={cls.listButton}

						onClick={() => {
							store.dispatch(setShowMenu(false));
							store.dispatch(setShowSideMenu(true));
							onSetSelectedProcess({
								name: item?.name,
								description: item?.description,
								id: item?.id,
								is_pinned: item?.is_pinned,
								user_id: item?.user_id,
								registered: true,
								type: item?.type,
								steps: item?.steps,
								shared_positions: item?.shared_positions
							});
							navigate('/workflow');
						}}
					>
						<div style={{ padding: '0 5px 0 5px', fontSize: '14px', fontWeight: 'bold', minWidth: '200px', textTransform: 'none', transform: 'scaleY(1.1)' }}>
							{item.name}
						</div>
					</button>
				))
				: null}

			{workflowTemplates?.length > 0 &&
				companyData?.status === 'superadmin' &&
				R.sortWith([R.ascend(R.prop('name'))])(workflowTemplates.filter(proc => proc.user_id === user.id || user.is_admin === true))?.slice(0, 10).map((item, index) => (
					<button
						key={index}
						className={cls.listButton}
						onClick={() => {
							store.dispatch(setShowMenu(false));
							store.dispatch(setShowSideMenu(true));
							onSetSelectedProcess({
								name: item?.name,
								description: item?.description,
								id: item?.id,
								is_pinned: item?.is_pinned,
								user_id: item?.user_id,
								registered: true,
								type: item?.type,
								steps: item?.steps,
							});
							navigate('/workflow');
						}}
					>
						<div style={{ padding: '0 5px 0 5px', fontSize: '14px', fontWeight: 'bold', minWidth: '200px', textTransform: 'none', transform: 'scaleY(1.1)' }}>
							{item.name}
						</div>

					</button>
				))}
			{(companyProcesses.length > 10 || (workflowTemplates.length > 10 && companyData?.status === 'superadmin' )) && <button
				className={cls.listButton}
				onClick={() => {
					navigate('/workflows');
				}}
			>
				<div style={{ padding: '0 5px 0 5px', fontSize: '14px', fontWeight: 'bold', minWidth: '160px', textTransform: 'none', textAlign: 'left', transform: 'scaleY(1.1)' }}>
					{'More Workflows'}
				</div>
			</button>
			}
			<div style={{width: '100%', display: (companyData?.status === 'active' || companyData?.status === 'superadmin') ? '' : (companyData?.status === 'on_trial' && companyProcesses.length < 10) ? '' : (companyData?.status === 'free' && companyProcesses.length === 0) ? '' : 'none' }}>
				<hr />
				<button
				style={{width: '100%', backgroundColor: firstModalVisible ? 'var(--app-color-gray-lighter)' : ''}}
				className={cls.listButton}
				onClick={() => {
					store.dispatch(setShowMenu(false));
					firstModalVisible && store.dispatch(setOnBoardingModalsVisibility({secondModalVisible: true}))
					onSetSelectedProcess({ description: '', id: '', is_pinned: false, name: '', user_id: '', registered: false, type: false });
					navigate('/workflow');
				}}
			>
				<div style={{padding: '0 5px', fontSize: '14px', fontWeight: 'bold', textTransform: 'none', color:'darkblue', transform: 'scaleY(1.1)' }}>
					{'New Workflow'}
				</div>
			</button>
			</div>			
		</div>
	);
}

const mapStateToProps = store => {
	const { companyPositionsArray, companyProcesses, workflowTemplates, companyData } = store.flowReducer;
	const { user } = store.sessionReducer;
	const { onBoardingModalsVisibility} = store.modalsReducer;
	return { companyPositionsArray, companyProcesses, user, workflowTemplates, companyData, onBoardingModalsVisibility };
};
const mapDispatchToProps = dispatch => {
	return { onSetSelectedProcess: process => dispatch(setSelectedProcess(process)) };
};
export default connect(mapStateToProps, mapDispatchToProps)(ProcessesMenu);
